<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    extends: TableView,

    props: {
        productId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false
        };
    },

    computed: {
        additionalFetchData() {
            return {
                id: this.productId
            };
        },

        labels() {
            return [
                { value: 'sku', width: '200px' },
                {
                    value: 'attributes',
                    filterable: false,
                    sortable: false,
                    filter(attributes) {
                        const parsed = attributes.map(({ group, value }) => {
                            const { name, unit } = group;

                            return `${name}: ${value}${unit || ''}`;
                        });

                        return parsed.join(', ');
                    },
                    width: '150px'
                },
                {
                    value: 'price',
                    width: '200px',
                    type: 'number',
                    filter: 'formatPrice'
                },
                {
                    value: 'stockAmount',
                    width: '200px',
                    type: 'number',
                    sum: true
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'products/getVariants',
            deleteItem: 'productVariants/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`variants/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('variants/add');
        }
    }
};
</script>
